import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import SquareLandingPage from '@99designs/acquisition-frontend/acquisition/components/SquareLandingPage';
import { Site } from '@99designs/site-navigation/lib/Site';
import DefaultPageLayout from '../components/common/DefaultPageLayout';
import { getDefaultPageProps } from '../lib/getDefaultPageProps';
import { DAY_IN_SECONDS, HOUR_IN_SECONDS } from '../lib/time';
import type { SiteConfig } from '@99designs/site-navigation/lib/Site';

export default function SquareOnlineStorePage({
    siteConfig,
    userRole,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
    const site = new Site(JSON.parse(siteConfig) as SiteConfig);

    return (
        <DefaultPageLayout role={userRole} site={site}>
            <SquareLandingPage />
        </DefaultPageLayout>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    const defaultProps = await getDefaultPageProps(context);

    context.res.setHeader('Surrogate-Key', 'square-online-store-builder-landing');
    context.res.setHeader(
        'Surrogate-Control',
        `max-age=${DAY_IN_SECONDS}, stale-while-revalidate=${HOUR_IN_SECONDS}`
    );

    return {
        props: {
            ...defaultProps,
        },
    };
};
